/* eslint-disable */

import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import client from '../../../api/client';

import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import OrderSummaryChart from '../../../components/chart/OrderSummary';
import moment from 'moment';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const MONTH_LABELS = [
  'มกราคม',
  'กุมภาพันธ์',
  'มีนาคม',
  'เมษายน',
  'พฤษภาคม',
  'มิถุนายน',
  'กรกฎาคม',
  'สิงหาคม',
  'กันยายน',
  'ตุลาคม',
  'พฤศจิกายน',
  'ธันวาคม',
];

function createDefaultChartData() {
  return MONTH_LABELS.map((label) => ({ label, y: 0, indexLabel: '0' }));
}

function MyShop_Seller_BusinessOverview(props) {
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const shopId = props.permitdata?.shop_id;
  const [chart_year, setChart_year] = useState(moment(new Date()).format('YYYY'));

  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  const onChangeYear = (date, dateString) => {
    if (dateString !== '') {
      setChart_year(dateString);
    }
  };

  const businessChartQuery = useQuery({
    queryKey: ['business-chart', shopId, chart_year],
    queryFn: async () => {
      await sleep(200);
      const formData = new FormData();
      formData.append('shop_id', shopId);
      formData.append('year', chart_year);

      const response = await client.post('/api/order/myshop/seller/businesschart', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'businesschart failed');
        err.isWarning = true;
        throw err;
      }
      return response.data.plot || [];
    },
    enabled: !!shopId && chart_year !== '',
  });

  const chart_data1 = useMemo(() => {
    const base = createDefaultChartData();
    const plot = businessChartQuery.data;
    if (!plot || plot.length === 0) return base;
    return base.map((item, index) => {
      const itemx = plot.find((p) => p.monthno - 1 === index);
      if (!itemx) return item;
      return {
        ...item,
        y: itemx.shop_income,
        indexLabel: itemx.shop_income.toString(),
      };
    });
  }, [businessChartQuery.data]);

  const chart_data2 = useMemo(() => {
    const base = createDefaultChartData();
    const plot = businessChartQuery.data;
    if (!plot || plot.length === 0) return base;
    return base.map((item, index) => {
      const itemx = plot.find((p) => p.monthno - 1 === index);
      if (!itemx) return item;
      return {
        ...item,
        y: itemx.shop_servicecharge,
        indexLabel: itemx.shop_servicecharge.toString(),
      };
    });
  }, [businessChartQuery.data]);

  useEffect(() => {
    if (businessChartQuery.isFetching) {
      setmodal_load({ enable: true, message: 'กำลังค้นข้อมูลการขาย' });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [businessChartQuery.isFetching]);

  useEffect(() => {
    if (!businessChartQuery.isError) return;
    setmodal_load({ enable: false, message: '' });
    setModal_popup({
      modaltype: businessChartQuery.error?.isWarning ? 'modal-warning' : 'modal-error',
      headers: businessChartQuery.error?.isWarning ? 'ขออภัย' : 'ผิดพลาด',
      message: businessChartQuery.error?.message ?? 'ผิดพลาด',
      enable: true,
    });
  }, [businessChartQuery.isError, businessChartQuery.error]);

  return (
    <div className='my-0 font-inter font-th'>
      <div className='row'>
        <div className='col-12'>
          <div className='form-group' style={{ maxWidth: '200px' }}>
            <label className='font-th' htmlFor='chart_year'>
              เลือกปีการค้า
            </label>
            <DatePicker
              allowClear={false}
              picker='year'
              onChange={onChangeYear}
              format={'YYYY'}
              className={'form-control-sm'}
              defaultValue={dayjs(new Date(chart_year + '-01-01'))}
            />
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-12'>
          <OrderSummaryChart
            chart_data1={chart_data1}
            chart_data2={chart_data2}
            chart_year={chart_year}
          ></OrderSummaryChart>

          <div className=''>
            <div className='font-th mt-3'>
              หมายเหตุ : ยอดขายที่แสดง คือยอดขายที่คำนวณจาก งานขายที่สำเร็จ, ยกเลิก,
              คืนเงิน/คืนสินค้าเท่านั้น ไม่รวมการขายที่อยู่ในระหว่างดำเนินการ
            </div>
          </div>
        </div>
      </div>

      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </div>
  );
}

export default MyShop_Seller_BusinessOverview;
